<template>
  <div>
    <Loading :loading="loading" message="Indlæser prisforslag" />
    <v-card>
      <v-toolbar
        flat
        class="mb-4"
        extended
        extension-height="70"
      >
        <v-toolbar-title>
          Prisforslag
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <div
          class="d-flex align-center"
          style="gap: 1rem;"
        >
          <v-btn
            :loading="loading"
            icon
            @click="fetchData"
          >
            <v-icon>
              mdi-refresh
            </v-icon>
          </v-btn>
          <v-sheet
            class="d-flex align-center py-1 px-2"
            style="gap: .5rem;"
            outlined
            rounded
          >
            <span class="px-2">
              {{ items.length }} total
            </span>
            <v-menu
              v-model="showConfirmApplyAll"
              bottom
              left
              origin="right"
            >
              <template #activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :loading="applying"
                  color="primary"
                  small
                >
                  Offentliggør
                  <v-icon right>
                    mdi-check
                  </v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  Er du sikker?
                </v-card-title>
                <v-card-text>
                  <v-alert type="warning" icon="mdi-alert-outline" dense>
                    Dette vil offentligtgøre <strong>ALLE ({{ items.length }})</strong> prisforslag der matcher de nuværende søgekriterier!
                  </v-alert>
                  De nye priser bliver synlige for de relevante kunder med det samme.
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    text
                    @click="showConfirmApplyAll = false"
                  >
                    Tilbage
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="applyPending(items.map(x => x.id))"
                  >
                    Ja, offentliggør {{ items.length }} priser
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-menu
              v-model="showConfirmAbortAll"
              bottom
              left
              origin="right"
            >
              <template #activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :loading="aborting"
                  color="error"
                  small
                >
                  Annuller
                  <v-icon right>
                    mdi-cancel
                  </v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  Er du sikker?
                </v-card-title>
                <v-card-text>
                  <v-alert type="warning" icon="mdi-alert-outline" dense>
                    <strong>Alle ({{ items.length }})</strong> prisforslag, der matcher de nuværende søgekriterier bliver annulleret, men vil blive foreslået igen senere.
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    text
                    @click="showConfirmAbortAll = false"
                  >
                    Tilbage
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="error"
                    @click="abortPending(items.map(x => x.id))"
                  >
                    Ja, annuller {{ items.length }} prisforslag
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
          <v-fade-transition>
            <v-sheet
              v-if="selected.length"
              class="d-flex align-center py-1 px-2"
              style="gap: .5rem;"
              outlined
              rounded
            >
              <span class="px-2">
                {{ selected.length }} valgt
              </span>
              <v-menu
                v-model="showConfirmApply"
                bottom
                left
                origin="right"
              >
                <template #activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :loading="applying"
                    color="primary"
                    small
                  >
                    Offentliggør
                    <v-icon right>
                      mdi-check
                    </v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    Er du sikker?
                  </v-card-title>
                  <v-card-text>
                    De nye priser bliver synlige for de relevante kunder med det samme.
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      @click="showConfirmApply = false"
                    >
                      Tilbage
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      @click="applyPending(selected.map(x => x.id))"
                    >
                      Ja, offentliggør priser
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-menu
                v-model="showConfirmAbort"
                bottom
                left
                origin="right"
              >
                <template #activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :loading="aborting"
                    color="error"
                    small
                  >
                    Annuller
                    <v-icon right>
                      mdi-cancel
                    </v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    Er du sikker?
                  </v-card-title>
                  <v-card-text>
                    Valgte prisforslag bliver annulleret, men vil blive foreslået igen senere.
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      @click="showConfirmAbort = false"
                    >
                      Tilbage
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="error"
                      @click="abortPending(selected.map(x => x.id))"
                    >
                      Ja, annuller prisforslag
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-fade-transition>
        </div>
        <template #extension>
          <v-row align="center" dense>
            <v-col cols="3">
              <v-text-field
                v-model="search"
                label="Søg"
                hide-details
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="selectedCustomerCategories"
                :items="customerCategories"
                label="Kundekategori"
                multiple
                hide-details
                small-chips
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model.number="min"
                label="Kundepris ændret fra"
                suffix="%"
                type="number"
                hide-details
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model.number="max"
                label="Kundepris ændret til"
                suffix="%"
                type="number"
                hide-details
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col cols="2">
              <div class="d-flex align-center justify-space-between" style="width: 100%; gap: 1rem;">
                <v-checkbox
                  v-model="onlyFavorites"
                  label="Vis kun favoritter"
                  class="mr-4"
                  hide-details
                />
                <v-menu
                  v-model="toggleColumnsMenu"
                  left
                  offset-y
                  :close-on-content-click="false"
                >
                  <template #activator="{ attrs, on }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                    >
                      <v-icon> mdi-table-cog </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="header in headers"
                      :key="header.value"
                    >
                      <v-list-item-content>
                        {{ header.text }}
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox
                          v-model="header.show"
                        />
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="visibleHeaders"
        :items="items"
        :loading="loading"
        :items-per-page="30"
        class="pt-4"
        sort-by="customerPriceDiffPct"
        sort-desc
        show-select
        no-data-text="Ingen data"
        no-results-text="Ingen resultater"
        loading-text="Indlæser prisforslag"
        :footer-props="{ 'items-per-page-options': [15, 30, 50, 75, -1] }"
        @dblclick:row="goToPart"
      >
        <template #[`item.ean`]="{ item }">
          <clipboard-copy>{{ item.ean }}</clipboard-copy>
        </template>
        <template #[`item.partNumber`]="{ item }">
          <clipboard-copy>{{ item.partNumber }}</clipboard-copy>
        </template>
        <template #[`item.tpaPartNumber`]="{ item }">
          <clipboard-copy>{{ item.tpaPartNumber }}</clipboard-copy>
        </template>
        <template #[`item.isFavorite`]="{ item }">
          <v-icon
            v-if="item.isFavorite"
            color="yellow"
          >
            mdi-star
          </v-icon>
        </template>
        <template #[`item.currentCostPrice`]="{ item }">
          {{ item.currentCostPrice | formatNumberFixed2 }}
        </template>
        <template #[`item.currentCustomerPrice`]="{ item }">
          {{ item.currentCustomerPrice | formatNumberFixed2 }}
        </template>
        <template #[`item.newCustomerPrice`]="{ item }">
          <PriceCalculationDetails
            :price="item.newCustomerPrice"
            :calculationCriteria="item.priceCalculationCriteria"
            :calculatedOn="item.priceCalculatedOn"
            :provider="item.priceCalculationProvider"
          />
        </template>
        <template #[`item.customerPriceDiff`]="{ item }">
          {{ item.customerPriceDiff | formatNumberFixed2 }}
        </template>
        <template #[`item.customerPriceDiffPct`]="{ item }">
          <span :class="{ 'red--text font-weight-bold': Math.sign(item.customerPriceDiffPct) === -1 }">
            {{ item.customerPriceDiffPct }}
          </span>
        </template>
        <template #[`item.suggestedRetailPrice`]="{ item }">
          {{ item.suggestedRetailPrice | formatNumberFixed2 }}
        </template>
        <template #[`item.suggestedRetailPriceDiffPct`]="{ item }">
          <span :class="{ 'red--text font-weight-bold': Math.sign(item.suggestedRetailPriceDiffPct) === -1 }">
            {{ item.suggestedRetailPriceDiffPct }}
          </span>
        </template>
      </v-data-table>

      <v-card-text>
        <div>
          Procentsatser er rundet op
        </div>
        <div class="text-caption">
          Tip: Dobbeltklik på en række for at gå til redigering af en vare
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import PriceCalculationDetails from '@/components/PriceCalculationDetails.vue'
import ClipboardCopy from '@/components/ClipboardCopy.vue'

export default {
  name: 'PricePendingAdmin',
  components: {
    Loading,
    PriceCalculationDetails,
    ClipboardCopy
  },
  data() {
    return {
      loading: false,
      applying: false,
      aborting: false,
      headers: [
        { text: 'Titel', value: 'title', width: '20%', show: true },
        { text: 'EAN', value: 'ean', show: true },
        { text: 'Varenummer', value: 'partNumber', show: true },
        { text: 'TPA Varenummer', value: 'tpaPartNumber', show: true },
        { text: 'Producent', value: 'manufacturer', show: true },
        { text: 'Favorit', value: 'isFavorite', align: 'center', show: true },
        { text: 'Kunde kategori', value: 'customerCategory', show: true },
        { text: 'Kostpris aktuel', value: 'currentCostPrice', align: 'end', show: true },
        { text: 'Kundepris aktuel', value: 'currentCustomerPrice', align: 'end', show: true },
        { text: 'Kundepris ny', value: 'newCustomerPrice', align: 'end', show: true },
        { text: 'Kundepris ændring', value: 'customerPriceDiff', align: 'end', show: true },
        { text: 'Kundepris ændring (%)', value: 'customerPriceDiffPct', align: 'end', show: true },
        { text: 'Vejl. salgspris', value: 'suggestedRetailPrice', align: 'end', show: true },
        { text: 'Kundepris vs. Vejl. (%)', value: 'suggestedRetailPriceDiff', align: 'end', show: true }
      ],
      onlyFavorites: false,
      pendingItems: [],
      min: null,
      max: null,
      search: this.$route.query.search ?? '',
      selected: [],
      selectedCustomerCategories: [],
      showConfirmApply: false,
      showConfirmApplyAll: false,
      showConfirmAbort: false,
      showConfirmAbortAll: false,
      toggleColumnsMenu: false,
    }
  },
  computed: {
    items() {
      let result = this.pendingItems.map(x => {
        return {
          ...x,
          customerPriceDiff: x.currentCustomerPrice ? x.newCustomerPrice - x.currentCustomerPrice : null,
          customerPriceDiffPct: x.currentCustomerPrice ? (((x.newCustomerPrice - x.currentCustomerPrice) / x.currentCustomerPrice) * 100).toFixed(0) : null,
          suggestedRetailPriceDiff: x.suggestedRetailPrice ? ((x.newCustomerPrice / x.suggestedRetailPrice) * 100).toFixed(0) : null
        };
      });

      if (!!this.search) {
        console.log('filtering')
        result = result.filter(item => {
          const { title, ean, partNumber, tpaPartNumber, manufacturer, customerCategory } = item;
          const itemSearchString = [ title, ean, partNumber, tpaPartNumber, manufacturer, customerCategory ].join().toLowerCase()

          return itemSearchString.includes(this.search.toLowerCase())
        })
      }

      if (this.selectedCustomerCategories.length) {
        result = result.filter(item => this.selectedCustomerCategories.includes(item.customerCategory))
      }

      if (typeof this.min === 'number') {
        result = result.filter(item => item.customerPriceDiffPct >= this.min)
      }

      if (typeof this.max === 'number') {
        result = result.filter(item => item.customerPriceDiffPct <= this.max)
      }

      if (this.onlyFavorites && this.pendingItems.length) {
        result = result.filter(item => item.isFavorite);
      }

      return result;
    },
    customerCategories() {
      const uniqueCategories = new Set(this.pendingItems.map(x => x.customerCategory));

      return [ ...uniqueCategories ];
    },
    visibleHeaders() {
      return this.headers.filter(header => header.show === true);
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        const { data } = await this.$api.get(`adminpart/PricePending`);

        this.pendingItems = data?.pendingItems;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    },
    goToPart(event, { item }) {
      const route = this.$router.resolve({ path: `/parts/${item.part_Id}/edit` });
      window.open(route.href, '_blank');
    },
    async applyPending(partCustomerDetailIds) {
      const data = {
        partCustomerDetailIds
      };

      try {
        this.applying = true;

        const response = await this.$api.post('adminpart/pricepending', data);

        if (!response.data.success) throw response.data;

        this.pendingItems = response.data?.model?.pendingItems;
        this.selected = [];
        this.$notifier.showSuccess({ message: 'Priser er offentliggjort' });
      } catch (error) {
        console.error(error);
        this.$notifier.showError({ message: 'Noget gik galt!' });
      } finally {
        this.applying = false;
      }
    },
    async abortPending(partCustomerDetailIds) {
      const data = {
        partCustomerDetailIds
      };

      try {
        this.aborting = true;

        const response = await this.$api.delete('adminpart/pricepending', {data: data});

        if (!response.data.success) throw response.data;

        this.pendingItems = response.data?.model?.pendingItems;
        this.selected = [];
        this.$notifier.showSuccess({ message: 'Prisændringerne er annulleret' });
      } catch (error) {
        console.error(error);
        this.$notifier.showError({ message: 'Noget gik galt!' });
      } finally {
        this.aborting = false;
      }
    }
  },
  async mounted() {
    this.fetchData();
  }
}
</script>